import { Routes, Route, Navigate } from 'react-router-dom';
import { AlertsList, AlertsAddEdit, AlertsManagement } from '.';

export { AlertsLayout };

function AlertsLayout() {

    return (
        <div className="pt-16 px-12">
            <Routes>
                <Route index element={<AlertsList />} />
                <Route path="gestion" element={<AlertsManagement />} />
                <Route path="add" element={<AlertsAddEdit />} />
                <Route path="edit/:preAlertId" element={<AlertsAddEdit />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </div>
    );
}
